/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Typography,
  Button,
  CircularProgress,
  Divider,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import {
  ConfirmModal,
  TranslationDictionary,
  useDisclosure,
  useLocale
} from '@plandi/common'
import { components } from '@plandi/common/src/generated'
import { useRouter } from 'next/router'
import React, { FC, useState } from 'react'
import Image from 'next/image'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import { MyProfileSpecialist } from '../profile-specialist.types'
import { useProfileSpecialistPortfolioNewStyles } from './profile-specialist-portfolio-new.styles'
import { useMutationDeleteProject } from 'src/features/portfolio/common/portfolio.mutation'

interface IProfileSpecialistPortfolioEditNewProps {
  profile: MyProfileSpecialist
  setShowEdit: (value: boolean) => void
  translate?: TranslationDictionary['data']
  locale: string
  projects?: components['schemas']['PortfolioProjectResource'][]
  type: 'freelancer' | 'worker'
}

export const ProfileSpecialistPortfolioEditNew: FC<
  IProfileSpecialistPortfolioEditNewProps
> = ({ profile, setShowEdit, projects, translate }) => {
  const [deleteProjectName, setDeleteProjectName] = useState('')
  const [deleteProjectId, setDeleteProjectId] = useState(0)
  const router = useRouter()
  const locale = useLocale()
  const handleCloseEdit = () => setShowEdit(false)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(900))

  const mutationDeleteProject = useMutationDeleteProject(profile?.id, {
    onSuccess: () => onCloseConfirm()
  })

  const {
    isOpen: isOpenConfirm,
    onOpen: onOpenConfirm,
    onClose: onCloseConfirm
  } = useDisclosure()

  const handleOpenConfirmDeleteProject = (
    event: React.SyntheticEvent<Element, Event>
  ) => {
    event.preventDefault()
    onOpenConfirm()
  }

  const handleCloseConfirm = (event: React.SyntheticEvent<Element, Event>) => {
    event.preventDefault()
    onCloseConfirm()
  }

  const handleDeleteProject = (
    event: React.MouseEvent<unknown, MouseEvent>,
    id?: number
  ) => {
    event.preventDefault()
    if (id) {
      mutationDeleteProject.mutate(id)
    }
  }

  const handleCreateProject = () => {
    router.push(
      {
        pathname: `/profile-specialist/${profile?.slug_name}/${profile?.id}/portfolio/create`
      },
      undefined,
      { shallow: true }
    )
  }

  function CircularProgressWithLabel(index: number) {
    return (
      <div style={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          className={classes.circular}
          size={40}
          thickness={1}
          value={100}
        />
        <div className={classes.circularPosition}>
          <Typography className={classes.circularText}>{index}</Typography>
        </div>
      </div>
    )
  }

  const classes = useProfileSpecialistPortfolioNewStyles()

  return (
    <>
      <div className={classes.top}>
        <Typography className={classes.header}>
          {locale === 'ru' ? 'Портфолио' : 'Portfolio'}
        </Typography>
        <div className={classes.infoBlock}>
          <Typography className={classes.infoText}>
            {locale === 'ru'
              ? 'Качественное портфолио увеличивает шансы на получение заказа. Заполнение этого раздела поможет получить дополнительные баллы для увеличения рейтинга анкеты и более высокой выдачи в каталоге.'
              : 'A quality portfolio increases your chances of getting an order. Filling out this section will help you get additional points to increase your profile rating and higher placement in the catalog.'}
          </Typography>
        </div>
        {projects && projects.length > 0
          ? projects.map((project, index) => (
              <div key={project.id} className={classes.topBlockEdit}>
                <div className={classes.topBlockNumber}>
                  <div className={classes.blockNumber}>
                    {CircularProgressWithLabel(index + 1)}
                    <Divider className={classes.divider} />
                  </div>
                  {isMobile ? (
                    <DeleteOutlineIcon
                      style={{ color: '#7A7A75' }}
                      onClick={(event) => {
                        handleOpenConfirmDeleteProject(event)
                        setDeleteProjectName(project.name ?? '')
                        setDeleteProjectId(project.id ?? 0)
                      }}
                    />
                  ) : (
                    <div className={classes.action}>
                      <DeleteOutlineIcon style={{ color: '#7A7A75' }} />
                      <Typography
                        className={classes.deleteText}
                        onClick={(event) => {
                          handleOpenConfirmDeleteProject(event)
                          setDeleteProjectName(project.name ?? '')
                          setDeleteProjectId(project.id ?? 0)
                        }}
                      >
                        {locale === 'ru'
                          ? 'Удалить проект из портфолио'
                          : 'Remove project from portfolio'}
                      </Typography>
                    </div>
                  )}
                </div>
                {project?.images?.length ? (
                  <div style={{ display: 'flex' }}>
                    <Typography className={classes.topHeaderEdit}>
                      {project?.images?.length === 0
                        ? `${locale === 'ru' ? 'Фотография' : 'Image'}`
                        : `${locale === 'ru' ? 'Фотографии' : 'Images'}`}
                    </Typography>
                    <div className={classes.projectImages}>
                      {project?.images?.map((image) => (
                        <Image
                          src={image.url ?? ''}
                          width={128}
                          height={96}
                          alt={project?.name}
                          className={classes.portfolioImage}
                          objectFit="cover"
                          priority
                          key={image.id}
                        />
                      ))}
                    </div>
                  </div>
                ) : null}
                <div style={{ display: 'flex', marginTop: 8 }}>
                  <Typography className={classes.topHeaderEdit}>
                    {locale === 'ru' ? 'Название' : 'Title'}
                  </Typography>
                  <Typography className={classes.portfolioNameEdit}>
                    {project?.name}
                  </Typography>
                </div>
                {project?.description ? (
                  <div style={{ display: 'flex' }}>
                    <Typography className={classes.topHeaderEdit}>
                      {locale === 'ru' ? 'Описание' : 'Description'}
                    </Typography>
                    <Typography className={classes.portfolioNameEdit}>
                      {project?.description}
                    </Typography>
                  </div>
                ) : null}
                <div className={classes.buttons}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.button}
                    onClick={() =>
                      router.push(
                        {
                          pathname: `/profile-specialist/${profile?.slug_name}/${profile?.id}/portfolio/${project?.slug}/edit`
                        },
                        undefined,
                        { shallow: true }
                      )
                    }
                  >
                    {locale === 'ru' ? 'Редактировать проект' : 'Edit project'}
                  </Button>
                </div>
              </div>
            ))
          : null}
        <div className={classes.topBlockNumber}>
          <div className={classes.blockNumber}>
            {CircularProgressWithLabel(projects ? projects?.length + 1 : 1)}
            <Divider className={classes.divider} />
          </div>
          {isMobile ? (
            <AddCircleOutlineIcon
              style={{ color: '#E52428' }}
              onClick={handleCreateProject}
            />
          ) : (
            <div className={classes.action}>
              <AddCircleOutlineIcon style={{ color: '#E52428' }} />
              <Typography
                className={classes.addText}
                onClick={handleCreateProject}
              >
                {locale === 'ru' ? 'Создать проект' : 'Create project'}
              </Typography>
            </div>
          )}
        </div>
        <div className={classes.buttons}>
          <Button
            variant="outlined"
            className={classes.buttonCancel}
            onClick={handleCloseEdit}
            style={{ marginRight: 0 }}
          >
            {locale === 'ru' ? 'Назад' : 'Back'}
          </Button>
        </div>
      </div>
      {isOpenConfirm && (
        <ConfirmModal
          title={`${
            translate?.['job-site']?.['want-delete-project'] ??
            'Вы уверены что хотите удалить проект'
          } “${deleteProjectName ?? ''}”? ${
            translate?.['job-site']?.['action-irreversible'] ??
            'Это действие необратимо'
          }`}
          isOpen={isOpenConfirm}
          onClose={handleCloseConfirm}
          onOk={(event: React.MouseEvent<unknown, MouseEvent>) =>
            handleDeleteProject(event, deleteProjectId)
          }
          translate={translate}
        />
      )}
    </>
  )
}
